import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Law } from "../../../../../models/laws";
import { Registration } from "../../../../../models/registration";
import { RegistrationLaw } from "../../../../../models/registration-law";
import { LawControllerService } from "../../../../../services/laws-controller/law-controller.service";
import { LawService } from "../../../../../services/laws-controller/law.service";
import { RegistrationLawControllerService } from "../../../../../services/laws-controller/registration-law-controller.service";
import { Store } from "../../../../../services/store.service";
import { BaseError } from "../../../base-error";

@Component({
  selector: "registration-law",
  templateUrl: "./law-registration.component.html",
  providers: [ToastrService],
})
export class RegistrationLawComponent extends BaseError implements OnInit, OnChanges, OnDestroy {

  @Input() public registration: Registration;
  @Input() public serviceId: string;
  @Input() public disabled: boolean = false;
  public registrationLawList: RegistrationLaw[] = [];
  public registrationLawListLength: number;
  public laws: Law[];
  public showLaws: any = {};
  public law: Law;
  public registrationLaw: RegistrationLaw;
  public showList: boolean = false;
  public addNew: boolean;
  public subscription: any;

  public searchLawFilter: any;

  constructor(private lawControllerService: LawControllerService,
              private registrationLawControllerService: RegistrationLawControllerService,
              private lawService: LawService,
              public store: Store,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.subscription = this.lawService.update.subscribe((data) => {
      if (data.update) {
        this.loadLaws();
      }
    });

  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public ngOnChanges() {
    this.loadLaws();
  }

  public dropped(event: CdkDragDrop<RegistrationLaw[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

      // component logic
      if (!this.disabled) {
        this.registrationLawList.forEach((it, index, itemsArray) => {
          itemsArray[index].sortOrder = index;
        });
        this.sortRegistrationLawList();
      }
    }
  }

  public loadLaws() {
    if (this.serviceId) {
      this.lawControllerService.getLawsList().subscribe(
        (data) => {
          this.laws = data.sort((a, b) => {
            const nameA = a.name && a.name.toLowerCase();
            const nameB = b.name && b.name.toLowerCase();
            if (nameA < nameB) {
              return -1;
            }
          });
          this.loadRegistrationLawList();
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public loadRegistrationLawList() {
    if (this.registration && this.registration.id) {
      this.registrationLawControllerService.getRegistrationLawsList(this.registration.id).subscribe(
        (data) => {
          this.updateData(data);
        },
      );
    }
  }

  public sortRegistrationLawList() {
    if (!this.disabled) {
      this.registrationLawControllerService.updateSortOrder(this.registrationLawList).subscribe(
        (data) => this.responseSuccessful("Registration Laws reordered!"),
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
      );
    }
  }

  public updateData(data) {
    this.showList = false;
    this.registrationLawList = data;
    this.registrationLawListLength = data.length;
    this.toggleRegistrationLawsFromLawsList();
  }

  public fixVisualEffectOnLawSelected(law): void {
    this.showList = false;
    const newRegistrationLaw: RegistrationLaw = new RegistrationLaw();
    newRegistrationLaw.id = law.id;
    newRegistrationLaw.law = law;
    newRegistrationLaw.registrationId = this.registration.id;
    newRegistrationLaw.sortOrder = null;
    this.registrationLawList.push(newRegistrationLaw);
  }

  public addRegistrationLaw(law) {
    if (!this.disabled && this.registration !== undefined) {
      this.law = law;
      this.registrationLaw = new RegistrationLaw();
      this.registrationLaw.law = this.law;

      // for visual effect
      this.fixVisualEffectOnLawSelected(law);

      this.registrationLawControllerService.createRegistrationLaw(this.registration.id, this.registrationLaw).subscribe(
        (data) => {
          this.showList = false;
          this.loadLaws();
          this.responseSuccessful("Law added to registration");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public toggleRegistrationLawsFromLawsList() {
    this.showLaws = {};
    for (let j = this.laws.length - 1; j >= 0; j--) {
      this.showLaws[this.laws[j].id] = true;
      for (let i = this.registrationLawList.length - 1; i >= 0; i--) {
        if (this.laws[j].id === this.registrationLawList[i].law.id) {
          this.showLaws[this.laws[j].id] = false;
        }
      }
    }
  }

  public deleteLaw(isConfirmed, lawId) {
    if (!this.disabled && isConfirmed) {
      this.registrationLawControllerService.deleteRegistrationLaw(lawId).subscribe(
        (data) => {
          this.loadRegistrationLawList();
          this.responseSuccessful("Law removed from registration");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public openEdit(registrationLaw: any) {
    if (!this.disabled) {
      if (registrationLaw) {
        this.registrationLaw = registrationLaw;
        if (this.laws && this.laws.length > 0) {
          this.laws.forEach((thisLaw: any) => {
            if (thisLaw.id === registrationLaw.law.id) {
              this.law = thisLaw;
            }
          });
        }
        this.addNew = false;
      } else {
        this.registrationLaw = new RegistrationLaw();
        this.law = new Law();
        if (this.searchLawFilter !== undefined) {
          this.law.name = this.searchLawFilter.name;
        }
        this.addNew = true;
      }
      this.updateEditData();
    }
  }

  public showOrAdd() {
    if (!this.disabled) {
      if (this.laws.length > 0 && this.registrationLawListLength !== this.laws.length) {
        this.showList = !this.showList;
      } else {
        this.openEdit(false);
      }
    }
  }

  public updateEditData() {
    if (!this.disabled) {
      this.showList = false;
      this.store.state.common.sections.type = "law";
      this.lawService.serviceId = this.serviceId;
      this.lawService.registration = this.registration;
      this.lawService.law = this.law;
      this.lawService.registrationLaw = this.registrationLaw;
      this.lawService.initEdit();
    }
  }

  public searchLawChanged(value: any): void {
    this.searchLawFilter = { name: value };
  }
}
